var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-33ec4b1b-85d4-4f3e-ba2b-b32703f0aaba",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350.48734 108.09863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-d88bc497-2ace-45ee-8d86-5e29f3b5be05",
    "data-name": "button_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.24362,
    y: 18.23852,
    width: 259.99999,
    height: 71.6217,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "50.87702 102.09792 2.82843 54.04932 50.87702 6.00072",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46.29052 42.58972 25.70282 22.00202 46.29052 1.41422 55.17143 10.29512 102.50452 10.29512 110.38922 18.17982",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46.29052 65.50892 25.70282 86.09672 46.29052 106.68442 55.17143 97.80362 102.50452 97.80362 110.38922 89.91882",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.24172,43.89982l10.1494,10.1495-10.1494,10.1495-10.1495-10.1495,10.1495-10.1495m0-5.6568l-15.8064,15.8063,15.8064,15.8064,15.8063-15.8064-15.8063-15.8063h0Z",
    fill: "#ffd58d"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "299.61031 102.09792 347.65891 54.04932 299.61031 6.00072",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "304.19671 42.58972 324.78451 22.00202 304.19671 1.41422 295.31591 10.29512 247.98281 10.29512 240.09801 18.17982",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "304.19671 65.50892 324.78451 86.09672 304.19671 106.68442 295.31591 97.80362 247.98281 97.80362 240.09801 89.91882",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.24561,43.89982l10.1495,10.1495-10.1495,10.1495-10.1495-10.1495,10.1495-10.1495m0-5.6568l-15.8063,15.8063,15.8063,15.8064,15.8064-15.8064-15.8064-15.8063h0Z",
    fill: "#ffd58d"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "182.77321 17.96982 175.24361 10.44022 167.71412 17.96982",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "182.77321 90.12892 175.24361 97.65852 167.71412 90.12892",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBorder);
export default __webpack_public_path__ + "static/media/button-border.b67abe40f9a9682c75c53e041c0ccf12.svg";
export { ForwardRef as ReactComponent };